import { render, staticRenderFns } from "./Filter-programs.vue?vue&type=template&id=2fdbe91d&scoped=true"
import script from "./Filter-programs.vue?vue&type=script&lang=js"
export * from "./Filter-programs.vue?vue&type=script&lang=js"
import style0 from "./Filter-programs.vue?vue&type=style&index=0&id=2fdbe91d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbe91d",
  null
  
)

export default component.exports